import { CompletedRoute, PathType } from './types'

export const getStops = (path: PathType[]) =>
  `via ${path
    .slice(1, -1)
    .map((p) => p.name)
    .join(', ')}`

export const getFormattedMinutesHours = (totalMinutes: number): string => {
  const totalHours = Math.floor(totalMinutes / 60)
  const restMinutes = totalMinutes % 60
  const hoursFormat = totalHours > 0 ? `${totalHours}h` : ''
  const minutesFormat = `${String(restMinutes).padStart(2, '0')}m`
  return `${hoursFormat} ${minutesFormat}`
}

export const getFormattedDayMinutesHours = (totalMinutes: number): string => {
  const totalDays = Math.floor(totalMinutes / (60 * 24))
  const totalHours = Math.floor(totalMinutes / 60)
  const restHours = totalHours % 24
  const restMinutes = totalMinutes % 60
  const totalDaysFormat = totalDays > 0 ? `${totalDays}d` : ''
  const restHoursFormat = restHours > 0 ? `${restHours}h` : ''
  const restMinutesFormat = `${String(restMinutes).padStart(2, '0')}m`
  return `${totalDaysFormat} ${restHoursFormat} ${restMinutesFormat}`
}

export const getMinMaxTime = (routes: Required<CompletedRoute>[]): [number, number] | [number] => {
  const sortedRoutes = [...routes].sort((routeA, routeB) => routeA.total_time - routeB.total_time)
  const min = sortedRoutes[0].total_time
  const max = sortedRoutes[sortedRoutes.length - 1].total_time
  if (min === max) return [min]
  return [min, max]
}
